import { render } from "./trusted-section.vue?vue&type=template&id=050a0bbe"
import script from "./trusted-section.vue?vue&type=script&lang=js"
export * from "./trusted-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__